import React, { useState, useEffect, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert";

// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Form,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  Table,
  Modal
} from "react-bootstrap";

import AuthenContext from "../models/AuthenContext";
import ButtonLoading from "../components/Controls/ButtonLoading";

function Stamp() {
  const {authen, setIsLogin} = useContext(AuthenContext);

  const [validated, setValidated] = useState(false);

  const [alert, setAlert] = useState({
    "show": false,
    "text": ""
  });

  const initForm = {
    "stamp_name": "",
    "stamp_address": ""
  };

  const [form, setForm] = useState(initForm);
  const [loadingSave, setLoadingSave] = useState(false);

  useEffect(() => {
    loadEdit();
  }, []);

  const handleFormInputChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  }

  const loadEdit = () => {
    axios.post(process.env.REACT_APP_API_URL + "/school/stamp.get", {
      "api_key": process.env.REACT_APP_API_KEY,
      "token": authen.token
    })
    .then((res) => {
      let { status, data } = res.data;
      if(status == 1) {
        setForm(data);
        setValidated(false);
      }
      else if(status == -1) {
        setIsLogin(false);
      }
      else {
        setAlert({
          "show": true,
          "text": res.data.msg
        });
      }
    })
    .catch((ex) => {
      console.log(ex);
      setAlert({
        "show": true,
        "text": process.env.REACT_APP_SERVER_NOT_CONNECT
      });
    })
    .finally(() => {
      
    });
  }

  const formSubmit = (e) => {
    e.preventDefault();

    let is_valid = false;
    if(e.currentTarget.checkValidity() === false) {
      is_valid = false;
      e.stopPropagation();
    }
    else {
      is_valid = true;
    }

    setValidated(true);

    if(is_valid) {
      setLoadingSave(true);

      axios.post(process.env.REACT_APP_API_URL + "/school/stamp.set", {
        "api_key": process.env.REACT_APP_API_KEY,
        "token": authen.token,
        ...form
      })
      .then((res) => {
        let { status, data } = res.data;
        if(status == 1) {
          //loadEdit();
        }

        setAlert({
          "show": true,
          "text": res.data.msg
        });
      })
      .catch((ex) => {
        console.log(ex);
      })
      .finally(() => {
        setLoadingSave(false);
      });
    }
  }

  return (
    <>
      <Container>
        <Row className="justify-content-md-center align-items-center">
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4" className="text-center">ตราประทับ</Card.Title>
              </Card.Header>
              <Card.Body>
                <Form noValidate validated={validated} onSubmit={formSubmit}>
                  <Form.Group>
                    <label>ชื่อหน่วยงาน</label>
                    <Form.Control type="text" name="stamp_name" value={form.stamp_name} placeholder="" onChange={handleFormInputChange} required></Form.Control>
                    <Form.Control.Feedback type="invalid">กรุณาป้อน ชื่อหน่วยงาน</Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group>
                    <label>ที่อยู่</label>
                    <Form.Control type="text" name="stamp_address" value={form.stamp_address} placeholder="" onChange={handleFormInputChange} required></Form.Control>
                    <Form.Control.Feedback type="invalid">กรุณาป้อน ที่อยู่</Form.Control.Feedback>
                  </Form.Group>
                  <div className="text-center">
                    <ButtonLoading type="submit" icon="fas fa-check" className="btn btn-info btn-fill" loading={loadingSave}>บันทึก</ButtonLoading>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {
        alert.show && <SweetAlert
                        title={alert.text}
                        onConfirm={() => setAlert({"show": false})}
                        btnSize="md"
                        confirmBtnBsStyle="info"
                        confirmBtnCssClass="btn-fill"
                        confirmBtnStyle={{"border":"none","boxShadow":"none"}} />
      }
    </>
  );
}

export default Stamp;
